import React from 'react';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Arrow from 'src/app/icons/Monospaced/Arrow/Arrow';
import { SpacingPropKeys } from 'src/app/styles/spacing';

interface LeftAndRightArrowButtonsProps {
  onLeftClick: () => void;
  onRightClick: () => void;
  gap?: SpacingPropKeys;
  gapSm?: SpacingPropKeys;
}

const LeftAndRightArrowButtons = ({
  onLeftClick,
  onRightClick,
  gap,
  gapSm,
}: LeftAndRightArrowButtonsProps): JSX.Element => (
  <Stack
    gap={gap}
    gapSm={gapSm}
    justify='center'
    align='center'
  >
    <Button
      onClick={onLeftClick}
      variant='outline'
      radius='radius-circle'
      icon={<Arrow orientation='left' />}
      size='xl'
      data-track-id='carousel-prev'
    />
    <Button
      onClick={onRightClick}
      variant='outline'
      radius='radius-circle'
      icon={<Arrow orientation='right' />}
      size='xl'
      data-track-id='carousel-next'
    />
  </Stack>
);

export default LeftAndRightArrowButtons;
